import { isOneOf } from '../helpers/is-one-of.js'

export const OUTBOUND_EMAIL_CATEGORIES = [
  'ATTORNEY_PACKAGE',
  'TITLE_REQUEST',
  'COMPANY_INVITE',
  'BORROWER_INVITE',
  'PLATFORM_INVITE',
  'PASSWORD_RESET',
  'OTHER',
] as const

export type OutboundEmailCategory = (typeof OUTBOUND_EMAIL_CATEGORIES)[number]

export function isOutboundEmailCategory(
  value: string,
): value is OutboundEmailCategory {
  return isOneOf(value, OUTBOUND_EMAIL_CATEGORIES)
}

export const OUTBOUND_EMAIL_CATEGORY_LABELS: Record<
  OutboundEmailCategory,
  string
> = {
  ATTORNEY_PACKAGE: 'Attorney notification',
  TITLE_REQUEST: 'Title request',
  COMPANY_INVITE: 'Company invite',
  BORROWER_INVITE: 'Borrower invite',
  PLATFORM_INVITE: 'User invite',
  PASSWORD_RESET: 'Password reset',
  OTHER: 'Email',
}

export const OUTBOUND_EMAIL_STATUSES = [
  'SENT',
  'CONSOLE',
  'FAILED',
] as const

export type OutboundEmailStatus = (typeof OUTBOUND_EMAIL_STATUSES)[number]

export function isOutboundEmailStatus(
  value: string,
): value is OutboundEmailStatus {
  return isOneOf(value, OUTBOUND_EMAIL_STATUSES)
}

export const OUTBOUND_EMAIL_OBJECT_TYPES = [
  'LOAN',
  'COMPANY',
  'INVITATION',
] as const

export type OutboundEmailObjectType =
  (typeof OUTBOUND_EMAIL_OBJECT_TYPES)[number]

export function isOutboundEmailObjectType(
  value: string,
): value is OutboundEmailObjectType {
  return isOneOf(value, OUTBOUND_EMAIL_OBJECT_TYPES)
}
